/**
 * Return window.history.pushState
 * @return {Array}
 *
 * @example
 * import supportsHistory from '@meta-awesome/functions/src/supportsHistory'
 *
 * supportsHistory()
 * */
const supportsHistory = () => 'pushState' in window.history;

export default supportsHistory;
